import styled from "styled-components";
import { BREAKPOINTS } from "shared/hooks/useBreakpoint";

export const DESKTOP = `(min-width: ${BREAKPOINTS.lg}px)`;

/*
 * Papéis de cor nas telas de cadastro e edição:
 * - lightAmber → amber: palco (hero), igual ao da lista em /alertas
 * - mediumBlue / vividBlue: progresso, foco e detalhes de marca
 * - brightYellow: SOMENTE o botão principal de cada tela
 */

/* ───────────── Compartilhado ───────────── */

export const Stage = styled.section`
  background: linear-gradient(
    110deg,
    ${({ theme }) => theme.colors.lightAmber},
    ${({ theme }) => theme.colors.amber}
  );
  border-radius: 0 0 ${({ theme }) => theme.borderRadius.extraLarge}
    ${({ theme }) => theme.borderRadius.extraLarge};
  padding: ${({ theme }) => theme.spacing(6)} 0 ${({ theme }) => theme.spacing(8)};

  @media ${DESKTOP} {
    border-radius: 0 0 2.5rem 2.5rem;
    padding: ${({ theme }) => theme.spacing(8)} 0 ${({ theme }) => theme.spacing(10)};
  }
`;

export const StageInner = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto;

  @media ${DESKTOP} {
    width: 80%;
  }
`;

/** Encaixa o card do AlertForm na coluna e põe o amarelo só no botão enviar. */
export const CardSlot = styled.div`
  & button[type="submit"] {
    width: 100%;
    border-color: ${({ theme }) => theme.colors.brightYellow};
    background-color: ${({ theme }) => theme.colors.brightYellow};
    color: ${({ theme }) => theme.colors.ink};
    font-weight: ${({ theme }) => theme.fontWeights.bold};

    &:hover:not(:disabled) {
      border-color: ${({ theme }) => theme.colors.yellow};
      background-color: ${({ theme }) => theme.colors.yellow};
    }
  }
`;

export const BelowStage = styled.div`
  margin-top: ${({ theme }) => theme.spacing(8)};
`;

export const HowItWorks = styled.section`
  width: calc(100% - 32px);
  margin: ${({ theme }) => theme.spacing(8)} auto;

  @media ${DESKTOP} {
    width: 80%;
  }
`;

export const HowTitle = styled.h2`
  margin: 0 0 ${({ theme }) => theme.spacing(4)};
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

/** Três passos em colunas separadas por filete; sem caixas. */
export const StepsGrid = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: ${({ theme }) => theme.spacing(5)};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: ${({ theme }) => theme.spacing(8)};
  }
`;

export const StepItem = styled.li`
  padding-top: ${({ theme }) => theme.spacing(3)};
  border-top: 2px solid ${({ theme }) => theme.colors.mediumBlue};
`;

export const StepNumber = styled.span`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.colors.mediumBlue};
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1;
  font-variant-numeric: tabular-nums;
`;

export const StepTitle = styled.h3`
  margin: 0 0 ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

export const StepText = styled.p`
  margin: 0;
  max-width: 24rem;
  color: ${({ theme }) => theme.colors.mediumGray};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1.45;
`;
